module.exports = __webpack_public_path__ + "media/educators/160920-listbuilder-300x250-afc0a113.png";